<template>
  <div class="jsc-bg">
    <div class="top">
      <div class="sys-date">{{ today }}</div>
      <div class="sys-title">社团活动驾驶舱</div>
      <div class="sys-temp"><div id="he-plugin-simple"></div></div>
    </div>
    <div>
      <my-scale @changeSize="changeSize">
        <div
          :style="{
            'margin-top': 'calc(' + mySize + 'vw' + ' + 16px',
          }"
          class="d-aligncnter"
          style="width: 1920px"
        >
          <div class="left-box" id="table-content">
            <vue-seamless-scroll :data="clubList" :class-option="classOption" class="warp">
              <div class="club-card" v-for="(item, index) in clubList" :key="'club_' + index">
                <div
                  v-if="!!item.url"
                  class="clubImg"
                  style="overflow: hidden"
                  :style="{ backgroundImage: `url(${item.url})` }"
                >
                  <!-- <img
                    v-if="!!item.url"
                    :src="item.url"
                    style="width: 100%; height: 100%"
                  />
                  <img
                    v-else
                    src="../../../assets/img/clubcockpit/clubimg.svg"
                    style="width: 100%; height: 100%"
                  /> -->
                </div>
                <div v-else class="clubImg" style="overflow: hidden"></div>
                <div class="peoplenum">{{ item.strs }}人</div>
                <div class="club-info">
                  <div style="width: 186px" class="overflow">
                    {{ item.stmc }}
                  </div>
                  <div style="width: 186px" class="overflow" :title="item.zdls">指导老师：{{ item.zdls }}</div>
                  <div style="width: 186px" class="overflow" :title="item.lxdh">
                    联系电话：{{ !!item.lxdh ? item.lxdh : '暂未维护' }}
                  </div>
                </div>
              </div></vue-seamless-scroll
            >
          </div>
          <div class="right-box">
            <div class="right-top">
              <div class="each-box">
                <div class="d-aligncnter" style="margin: 16px 8px">
                  <img src="@/assets/img/sportteam/line1.svg" class="" />
                  <span class="ml-16">活动规模</span>
                  <img src="@/assets/img/sportteam/line2.svg" class="ml-16" />
                </div>
                <ActivitySize :activityScale="activityScale"></ActivitySize>
              </div>
              <div class="each-box">
                <div class="d-aligncnter" style="margin: 16px 8px">
                  <img src="@/assets/img/sportteam/line1.svg" class="" />
                  <span class="ml-16">活动数(上月/本月)</span>
                  <img src="@/assets/img/sportteam/line2.svg" class="ml-16" />
                </div>
                <ActivityBar :contrastList="contrastList"></ActivityBar>
              </div>
              <div class="each-box">
                <div class="d-aligncnter" style="margin: 16px 8px">
                  <img src="@/assets/img/sportteam/line1.svg" class="" />
                  <span class="ml-16">社团年级占比</span>
                  <img src="@/assets/img/sportteam/line2.svg" class="ml-16" />
                </div>
                <ActivityDegree :AssociationNumsData="AssociationNumsData"></ActivityDegree>
              </div>
            </div>
            <div class="right-center" style="display: none">
              <div class="d-aligncnter" style="padding: 8px 16px">
                <img src="@/assets/img/cockpit/school.svg" class="" />
                <span class="ml-16">社团纳新活动</span>
              </div>
              <NewList :nxList="nxList"></NewList>
            </div>
            <div class="right-bottom">
              <div class="d-aligncnter" style="padding: 8px 16px">
                <img src="@/assets/img/cockpit/plan.svg" class="" />
                <span class="ml-16">本学期社团活动</span>
              </div>
              <ActivityList :hdList="hdList"></ActivityList>
            </div>
          </div>
        </div>
      </my-scale>
    </div>
  </div>
</template>
<script>
import MyScale from '../components/MyScale.vue'
import ActivitySize from './ActivitySize.vue'
import ActivityBar from './ActivityBar.vue'
import ActivityDegree from './ActivityDegree.vue'
import ActivityList from './ActivityList.vue'
import NewList from './NewList.vue'
import {
  getAssociationInfo,
  AssociationScale,
  AssociationScaleQoq,
  AssociationRecruitment,
  AssociationActivity,
  getAssociationNums,
} from '@/api/api-association'
import vueSeamlessScroll from 'vue-seamless-scroll'
export default {
  name: '',
  components: {
    MyScale,
    ActivitySize,
    ActivityBar,
    ActivityDegree,
    ActivityList,
    NewList,
    vueSeamlessScroll,
  },
  data() {
    return {
      mySize: 5.208,
      currScale: 1,
      option1: {},
      currIndex: 0,
      timer: null,
      clubList: [1, 1, 11, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      activityScale: {},
      nxList: [],
      hdList: [],
      contrastList: {},
      currclubIndex: 0,
      classOption: {
        step: 0.4,
      },
      AssociationNumsData: [],
    }
  },
  created() {
    window.addEventListener('load', this.placeholderPic)
    window.addEventListener('resize', this.placeholderPic)
    // 时间
    let nowDate = new Date()
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate(),
      hours: nowDate.getHours(),
      minutes: nowDate.getMinutes(),
      seconds: nowDate.getSeconds(),
    }
    let newmonth = date.month > 9 ? date.month : '0' + date.month
    let newday = date.date > 9 ? date.date : '0' + date.date
    this.today = date.year + '-' + newmonth + '-' + newday
  },
  mounted() {
    // this.startScroll()
    this.getAssociationInfoList()
    this.getAssociationScale()
    this.getAssociationScaleQoq()
    this.getAssociationRecruitment()
    this.getAssociationActivity()
    this.getAssociationNumsData()
    window.onresize = () => {
      return (() => {})()
    }
    window.WIDGET = {
      CONFIG: {
        modules: '02',
        background: '5',
        tmpColor: 'FFFFFF',
        tmpSize: '16',
        cityColor: 'FFFFFF',
        citySize: '16',
        aqiColor: 'FFFFFF',
        aqiSize: '16',
        weatherIconSize: '24',
        alertIconSize: '18',
        padding: '10px 10px 10px 10px',
        shadow: '0',
        language: 'auto',
        fixed: 'false',
        vertical: 'top',
        horizontal: 'left',
        key: '18dcc59e188b4b6684d470c4322bbefa',
      },
    }
    ;(function (d) {
      var c = d.createElement('link')
      c.rel = 'stylesheet'
      c.href = 'https://widget.heweather.net/simple/static/css/he-simple.css?v=1.4.0'
      var s = d.createElement('script')
      s.src = 'https://widget.heweather.net/simple/static/js/he-simple.js?v=1.4.0'
      var sn = d.getElementsByTagName('script')[0]
      sn.parentNode.insertBefore(c, sn)
      sn.parentNode.insertBefore(s, sn)
    })(document)
  },
  methods: {
    changeCurrRace(item, index) {
      console.log('item:', item)
      this.currIndex = index
    },
    //字体大小
    placeholderPic() {
      const clientWidth = document.documentElement.clientWidth
      const n = 8 * (clientWidth / 380)
      document.documentElement.style.fontSize = n + 'px'
    },
    changeSize(size) {
      console.log('size:', size)
      //   if (Number(size) < 1) {
      this.currScale = size
      //   }
      //   this.mySize = this.mySize / size
      this.mySize = 5.208 / size
      //   var myChart1 = this.$echarts.init(document.getElementById('totalNum'))
    },
    getAssociationInfoList() {
      getAssociationInfo().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAssociationInfo:', res)
          this.clubList = res.data.obj
        }
      })
    },
    getAssociationScale() {
      AssociationScale().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAssociationInfo:', res)
          this.activityScale = res.data.obj
        }
      })
    },
    getAssociationScaleQoq() {
      AssociationScaleQoq().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAssociationInfo:', res)
          this.contrastList = res.data.obj
        }
      })
    },
    getAssociationRecruitment() {
      AssociationRecruitment().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAssociationInfo:', res)
          this.nxList = res.data.obj
        }
      })
    },
    getAssociationActivity() {
      AssociationActivity().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAssociationInfo:', res)
          this.hdList = res.data.obj
        }
      })
    },
    getAssociationNumsData() {
      getAssociationNums().then((res) => {
        if (res.data.statusCode == 1) {
          console.log('getAssociationNumsData:', res)
          this.AssociationNumsData = res.data.obj
          //   this.hdList = res.data.obj
        }
      })
    },
    // stopScroll() {
    //   console.log('stopScroll?')
    //   clearInterval(this.timer)
    //   this.timer = null
    // },
    // startScroll() {
    //   console.log('startScroll?')
    //   this.timer = setInterval(() => {
    //     if (this.clubList.length > 7) {
    //       if (this.currclubIndex < this.clubList.length - 1) {
    //         this.currclubIndex++
    //         document.getElementById('table-content').scrollTop =
    //           272 * this.currScale * this.currclubIndex
    //       } else {
    //         this.currclubIndex = 0
    //         document.getElementById('table-content').scrollTop = 0
    //       }
    //     }
    //   }, 5000)
    // },
  },
}
</script>
<style lang="scss" scoped>
.jsc-bg {
  width: 100vw;
  //   min-width: 1200px;
  height: 100vh;
  //   min-height: 800px;
  overflow: hidden;
  //   background: #09120f;
  background: #09120f url('../../../assets/img/cockpit/home-bg.svg') no-repeat center;

  color: #fff;

  .top {
    width: 100%;
    height: 5.208vw;
    background: url('../../../assets/img/cockpit/top.svg') no-repeat;
    background-size: 100%;
    position: relative;

    .sys-title {
      width: 100%;
      height: 100%;
      line-height: 5.208vw;
      vertical-align: middle;
      text-align: center;
      font-size: 1rem;
    }

    .sys-date,
    .sys-temp {
      font-size: 0.5rem;
      position: absolute;
    }

    .sys-date {
      line-height: 44px;
      top: calc(2.604vw - 18px);
      left: 6vw;
    }

    .sys-temp {
      top: calc(2.604vw - 22px);
      right: 6vw;
      display: flex;
      flex-direction: row-reverse;
    }
  }
}

.sys-temp ::v-deep .s-sticker-tmp {
  font-size: 0.5rem !important;
}

.sys-temp ::v-deep img {
  height: 0.7rem !important;
  width: 0.7rem !important;
}

.sys-temp ::v-deep #weather-view-he {
  display: none !important;
}
::-webkit-scrollbar {
  display: none;
}
.left-box {
  height: 940px;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 320px;
  margin: 0 24px;
  .club-card {
    position: relative;
    width: 272px;
    height: 76px;
    padding: 24px;
    background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
    opacity: 0.9;
    border-radius: 16px;
    display: flex;
    justify-items: center;
    margin-bottom: 16px;
  }
}
.right-box {
  width: 1525px;
  .right-top {
    height: 305px;
    display: flex;
    justify-content: space-between;
    .each-box {
      width: 492.33px;
      height: 305px;
      background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
      opacity: 0.9;
      font-size: 20px;
    }
  }
  .right-center {
    font-size: 20px;
    margin-top: 16px;
    height: 297px;
    background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
  }
  .right-bottom {
    font-size: 20px;
    margin-top: 16px;
    // height: 624px;
    // height: 624px;
    background: linear-gradient(180deg, rgba(26, 135, 95, 0.045) 0%, rgba(0, 122, 77, 0.09) 100%);
  }
}
.clubImg {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-image: url('../../../assets/img/clubcockpit/clubimg.svg');
  position: relative;
  background-repeat: no-repeat;
  background-size: auto 64px;
  background-position: center;
}
.peoplenum {
  position: absolute;
  bottom: 26px;
  left: 30px;
  width: 32px;
  height: 19px;
  padding: 1px 8px;
  background: #09120f;
  border-radius: 100px;
  text-align: center;
  white-space: nowrap;
  font-size: 10px;
  line-height: 19px;
}
.club-info {
  margin-left: 16px;
  font-size: 16px;
  div {
    margin-bottom: 4px;
  }
}
.ml-16 {
  margin-left: 16px;
}
</style>
